import { useEffect } from "react";

export default function NewsletterPopup() {
    useEffect(() => {
        // Vérifier si le script n'existe pas déjà pour éviter les doublons
        if (!document.querySelector("script[data-form='f95d311c-9d17-11f0-bf57-87f52e086a53']")) {
            const script = document.createElement("script");
            script.src = "https://eomail5.com/form/f95d311c-9d17-11f0-bf57-87f52e086a53.js";
            script.async = true;
            script.dataset.form = "f95d311c-9d17-11f0-bf57-87f52e086a53";
            document.getElementById("newsletter-popup-container").appendChild(script);
        }
    }, []);

    return (
        <div id="newsletter-popup-container"></div>
    );
}
